/* eslint-disable */
<template>
  <!-- Loxes -->
    <div class="maintop">
      <div class="loxes main-top">
        <div class="lox">
          <i class="fa fa-cart-plus text-danger" aria-hidden="true"></i>
          <p class="pt-4">Nigerian Based Fashion Retailer</p>
        </div>
        <div class="lox">
          <i class="fa fa-shopping-basket text-success" aria-hidden="true"></i>
          <p class="pt-4">over 65 New Arrivals Every Week</p>
        </div>
        <div class="lox hide-on-tablet">
          <i class="fa fa-archive text-primary" aria-hidden="true"></i>
          <p class="pt-4">Stores Across The Country</p>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: "AboutGrid"
};
</script>

<style></style>
